







































































































import Vue from 'vue';

import { useSave } from '@/composables';
import { BaseModuleEditor } from '../base';
import ConditionalEditorContainer from '../components/ConditionalEditorContainer.vue';

export default Vue.extend({
  name: 'SizeEditor',
  components: {
    ConditionalEditorContainer,
  },
  mixins: [BaseModuleEditor],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props: any) {
    const { buffer, save } = useSave(props, {
      path: 'size',
    });

    return {
      buffer,
      save,
    };
  },
});
